import Vue from "vue";
import Router from "vue-router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import auth from "@/router/auth";

Vue.use(Router);

function checkSession(to, from, next) {
  if (Vue.prototype.$session.exists()) {
    auth.check().then((res) => {
      NProgress.done();
      if (res) {
        next();
      } else {
        next("/login");
      }
    });
  } else {
    NProgress.done();
    next("/login");
  }
}

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      redirect: {
        path: "/404",
      },
    },
    {
      path: "/404",
      name: "NotFound",
      component: () => import("@/pages/errors/404.vue"),
    },
    {
      path: "/403",
      name: "AccessDenied",
      component: () => import(`@/pages/errors/403.vue`),
    },
    {
      path: "/login",
      name: "Login",
      component: () => import(`@/pages/Login.vue`),
      beforeEnter(to, from, next) {
        if (Vue.prototype.$session.exists()) {
          auth.check().then((res) => {
            NProgress.done();
            if (res) {
              next("/home");
            } else {
              next();
            }
          });
        } else {
          NProgress.done();
          next();
        }
      },
    },
    {
      path: "/forgot",
      name: "Forgot",
      component: () => import(`@/pages/Forgot.vue`),
      beforeEnter(to, from, next) {
        if (Vue.prototype.$session.exists()) {
          auth.check().then((res) => {
            NProgress.done();
            if (res) {
              next("/home");
            } else {
              next();
            }
          });
        } else {
          NProgress.done();
          next();
        }
      },
    },
    {
      path: "/reset",
      name: "Reset",
      component: () => import(`@/pages/Reset.vue`),
      beforeEnter(to, from, next) {
        if (Vue.prototype.$session.exists()) {
          auth.check().then((res) => {
            NProgress.done();
            if (res) {
              next("/home");
            } else {
              next();
            }
          });
        } else {
          NProgress.done();
          next();
        }
      },
    },
    {
      path: "/aviso-privacidad",
      name: "NoticePrivacy",
      component: () => import(`@/pages/NoticePrivacy.vue`),
    },
    {
      path: "/encuestas/fotos",
      name: "Photos",
      component: () => import(`@/pages/Photos.vue`),
    },
    {
      path: "/encuestas/fotos-combinadas",
      name: "PhotosCombined",
      component: () => import(`@/pages/PhotosCombined.vue`),
    },
    {
      path: "/actividades/fotos",
      name: "PhotosActivity",
      component: () => import(`@/pages/PhotosActivity.vue`),
    },
    {
      path: "/",
      name: "Root",
      redirect: {
        name: "Home",
      },
      component: () => import(`@/pages/Root.vue`),
      children: [
        {
          path: "/home",
          name: "Home",
          component: () => import(`@/pages/Home.vue`),
          beforeEnter: checkSession,
        },
        {
          path: "/administracion/empresas",
          name: "Empresas",
          component: () => import(`@/pages/catalogos/Empresas.vue`),
          beforeEnter: checkSession,
        },
        {
          path: "/administracion/plazas",
          name: "Plazas",
          component: () => import(`@/pages/catalogos/Plazas.vue`),
          beforeEnter: checkSession,
        },
        {
          path: "/administracion/subdirecciones",
          name: "Subdirecciones",
          component: () => import(`@/pages/catalogos/Subdirecciones.vue`),
          beforeEnter: checkSession,
        },
        {
          path: "/administracion/gerencias",
          name: "Gerencias",
          component: () => import(`@/pages/catalogos/Gerencias.vue`),
          beforeEnter: checkSession,
        },
        {
          path: "/administracion/tiposservicio",
          name: "TiposServicio",
          component: () => import(`@/pages/catalogos/TiposServicio.vue`),
          beforeEnter: checkSession,
        },
        {
          path: "/administracion/usuarios",
          name: "Usuarios",
          component: () => import(`@/pages/catalogos/Usuarios.vue`),
          beforeEnter: checkSession,
        },
        {
          path: "/administracion/configuracion-marca-agua",
          name: "ConfiguracionMarcaAgua",
          component: () =>
            import(`@/pages/catalogos/ConfiguracionMarcaAgua.vue`),
          beforeEnter: checkSession,
        },
        {
          path: "/operacion/preguntas",
          name: "Preguntas",
          component: () => import(`@/pages/Preguntas.vue`),
          beforeEnter: checkSession,
        },
        {
          path: "/operacion/respuestas",
          name: "Respuestas",
          component: () => import(`@/pages/Respuestas.vue`),
          beforeEnter: checkSession,
        },
        {
          path: "/operacion/encuestas",
          name: "Encuestas",
          component: () => import(`@/pages/Encuestas.vue`),
          beforeEnter: checkSession,
        },
        {
          path: "/operacion/tiendas",
          name: "Tiendas",
          component: () => import(`@/pages/Tiendas.vue`),
          beforeEnter: checkSession,
        },
        {
          path: "/operacion/actividades",
          name: "Actividades",
          component: () => import(`@/pages/Actividades.vue`),
          beforeEnter: checkSession,
        },
        {
          path: "/operacion/resultados",
          name: "Resultados",
          component: () => import(`@/pages/Resultados.vue`),
          beforeEnter: checkSession,
        },
        {
          path: "/operacion/resultadosPDF",
          name: "ResultadosPDF",
          component: () => import(`@/pages/ResultadosPDF.vue`),
          beforeEnter: checkSession,
        },
        {
          path: "/operacion/temporales",
          name: "Temporales",
          component: () => import(`@/pages/Temporales.vue`),
          beforeEnter: checkSession,
        },
        {
          path: "/reportes/tabularencuesta",
          name: "TabularEncuesta",
          component: () => import(`@/pages/reportes/TabularEncuesta.vue`),
          beforeEnter: checkSession,
        },
        {
          path: "/reportes/tabularencuestav2",
          name: "TabularEncuestaV2",
          component: () => import(`@/pages/reportes/TabularEncuestaV2.vue`),
          beforeEnter: checkSession,
        },
        {
          path: "/administracion/usuarios-disponibles",
          name: "UsuariosDisponibles",
          component: () =>
            import("@/pages/catalogos/UsuariosDisponibles.vue"),
          beforeEnter: checkSession,
        },
        {
          path: "/reportes/exportaciones-programadas",
          name: "ExportacionesProgramadas",
          component: () =>
            import(`@/pages/reportes/ExportacionesProgramadas.vue`),
          beforeEnter: checkSession,
        },
        {
          path: "/reportes/tabularencuestaPROMOPM",
          name: "TabularEncuestaPROMOPM",
          component: () =>
            import(`@/pages/reportes/TabularEncuestaPROMOPM.vue`),
          beforeEnter: checkSession,
        },
        {
          path: "/reportes/tabularencuestaMERCHPM",
          name: "TabularEncuestaMERCHPM",
          component: () =>
            import(`@/pages/reportes/TabularEncuestaMERCHPM.vue`),
          beforeEnter: checkSession,
        },
        {
          path: "/reportes/avanceplaza",
          name: "AvancePlaza",
          component: () => import(`@/pages/reportes/AvancePlaza.vue`),
          beforeEnter: checkSession,
        },
        {
          path: "/reportes/avanceusuario",
          name: "AvanceUsuario",
          component: () => import(`@/pages/reportes/AvanceUsuario.vue`),
          beforeEnter: checkSession,
        },
        {
          path: "/historicos/tabularencuesta",
          name: "Historico",
          component: () => import(`@/pages/historicos/TabularEncuesta.vue`),
          beforeEnter: checkSession,
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  NProgress.start();
  next();
});

router.afterEach((to, from) => {
  NProgress.done();
});

export default router;
